import Box from '@mui/material/Box';
import type { BoxProps } from '@repo/ui';
import { boxStyleIconWrapper } from '@repo/ui';

export function LoanProcessStatusIconWrapper({ iconType, children, ...rest }: BoxProps) {
  return (
    <Box {...rest} padding="20px" sx={boxStyleIconWrapper[iconType]}>
      {children}
    </Box>
  );
}
